import { createSlice } from '@reduxjs/toolkit';

const ContractSlice = createSlice({
    name: 'ContractOutputSlice',
    initialState:{
        show: false,
        id: '',
        popup: false,
    },
    reducers:{
        showContract: (state,action) =>{
            state.show = true
            state.id = action.payload.credential
        },
        hideContract: (state) =>{
            state.show = false
            state.id = ''
        },
        showPopup: (state,action) =>{
            state.popup = true
            state.id = action.payload.credential
        },
        hidePopup: (state) =>{
            state.popup = false
            state.id = ''
        },
        editContract: (state,action) =>{
            state.id = action.payload.credential
        }
    }
})

export const {showContract,hideContract,showPopup,hidePopup,editContract} = ContractSlice.actions;
export default ContractSlice;